var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.data, expression: "data" }
      ],
      on: {
        click: function($event) {
          return _vm.fnClick(_vm.data)
        }
      }
    },
    [_c("el-tag", { staticClass: "tag-pimary" }, [_vm._v(_vm._s(_vm.data))])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f49b4a96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f49b4a96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listRef.vue
// module id = null
// module chunks = 